/** Path constants — never hardcode a route string. */
export const ROUTES = {
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  verify: '/verify',
  createStore: '/create-store',
  onboarding: '/onboarding',
  join: '/join',
  connections: '/connections',

  shop: {
    root: '/shop',
    category: (id: string) => `/shop/c/${id}`,
    cart: '/shop/cart',
    orders: '/shop/orders',
    order: (id: string) => `/shop/orders/${id}`,
  },

  admin: {
    root: '/admin',
    categories: '/admin/categories',
    suppliers: '/admin/suppliers',
    products: '/admin/products',
    productNew: '/admin/products/new',
    product: (id: string) => `/admin/products/${id}`,
    settings: '/admin/settings',
    stock: '/admin/stock',
    stockProduct: (id: string) => `/admin/stock/products/${id}`,
    stockWriteOffs: '/admin/stock/write-offs',
    clients: '/admin/clients',
    orders: '/admin/orders',
    orderNew: '/admin/orders/new',
    order: (id: string) => `/admin/orders/${id}`,
    reports: '/admin/reports',
    payments: '/admin/payments',
    /** The payments page filtered to one counterparty. */
    paymentsOf: (counterpartyId: string) => `/admin/payments?cp=${counterpartyId}`,
  },

  notFound: '/404',
  noAccess: '/no-access',
} as const;
